import "core-js/modules/es6.regexp.split";
import $ from 'jquery';
import store from '@/store';
import "./spark-md5";
import { detectBrowserInfo, XMLStr2XMLDoc, detectBrowser, detectOS, XOREncrypt } from "./CommonFunctions";
import { LangCtrl } from "./pageBase";
var osType;

// Windows插件
var ClientPluVer = '2,1,3,221';
var ClientPluMimeType = 'application/np-webclient5000-plugin';
var ClientPluDownLoadPath = '' + 'public/ocx/WebClient5000_VPPlugin.exe';
var ClientPluClassId = 'd1e05927-8a57-4e24-974f-bb8b76117fdf';

// MAC插件
var ClientPluVer_MAC = '3,0,0,5';
var ClientPluMimeType_MAC = 'application/x-NVMS9000';
var ClientPluDownLoadPath_MAC = '' + 'OCX/NVMS9000.pkg';
var OCX_XML_Header = '<?xml version="1.0" encoding="utf-8" ?>"';
var OCXLang = ''; // 插件翻译内容

/*
 *	加载OCX
 contentId：控件容器ID
 objectId：控件ID
 */
export function LoadPlugin(contentId, objectId) {
  var $content = $('#' + contentId);
  var ocx = null;
  osType = detectOS();
  return new Promise(function (resolve, reject) {
    switch (osType) {
      case 'windows':
        LoadWinPlugin($content, objectId, ClientPluMimeType, ClientPluVer, ClientPluClassId, ClientPluDownLoadPath).then(function (res) {
          ocx = res;
          resolve(ocx);
        });
        break;
      case 'mac':
        LoadWinPlugin($content, objectId, ClientPluMimeType_MAC, ClientPluVer_MAC, ClientPluDownLoadPath_MAC).then(function (res) {
          ocx = res;
          resolve(ocx);
        });
        break;
      default:
        alert("The plugin don't support current operating system!");
        resolve(ocx);
    }
  });
}

// 获取“初始化OCX”的XML命令字符串
// para: Interactive(交互模式)/ReadOnly(只读模式)/Fixed
export function OCX_XML_Initial(model, lang, notifyFunName, viewType, screenNum) {
  var uiName;

  // 兼容对象化传参
  if (arguments.length === 1) {
    lang = arguments[0].lang;
    notifyFunName = arguments[0].notifyFunName;
    viewType = arguments[0].viewType;
    screenNum = arguments[0].screenNum;
    uiName = arguments[0].uiName;
    model = arguments[0].model;
  }
  var result = OCX_XML_Header + '<cmd type="Initial">';
  if (viewType) {
    result += '<viewType>' + viewType + '</viewType>';
  }
  if (model) {
    result += '<setModel>' + model + '</setModel>';
  }
  var langKeys = ['IDCS_FULLSCREEN', 'IDCS_CLOSE_IMAGE', 'IDCS_AUDIO_ON', 'IDCS_AUDIO_OFF', 'IDCS_VIDEO_PENDING', 'IDCS_UNKNOWN_ERROR_CODE', 'IDCS_FAILED', 'IDCS_NODE_NOT_ONLINE', 'IDCS_INVALID_PARAMETER', 'IDCS_DEVICE_BUSY', 'IDCS_NO_PERMISSION', 'IDCS_NOT_SUPPORTFUNC', 'IDCS_DEVICE_TYPE_ERR', 'IDCS_CONNECT_LIMIT', 'IDCS_SYNC_WAITTING', 'IDCS_LOCAL', 'IDCS_PLAYBACK_END', 'IDCS_NO_RECORDDATA', 'IDCS_MANUAL', 'IDCS_SCHEDULE', 'IDCS_INTELIGENCE_DETECTION', 'IDCS_POS', 'IDCS_MOTION_DETECTION', 'IDCS_SENSOR', 'IDCS_DEVICE_USER_NOTEXIST', 'IDCS_DEVICE_BUSY', 'IDCS_CHANNEL_NOTEXIST', 'IDCS_CONNECT_FAILED', 'IDCS_LOGIN_FAILED', 'IDCS_CHOOSE_FOLDER', 'IDCS_SET_CHANNEL_PALY_TIME_D', 'IDCS_SET_PALY_SYN_TIME_D', 'IDCS_NO_VIDEO_SIGNAL', 'IDCS_CALENDAR_JANUARY', 'IDCS_CALENDAR_FEBRUARY', 'IDCS_CALENDAR_MARCH', 'IDCS_CALENDAR_APRIL', 'IDCS_CALENDAR_MAY', 'IDCS_CALENDAR_JUNE', 'IDCS_CALENDAR_JULY', 'IDCS_CALENDAR_AUGUST', 'IDCS_CALENDAR_SEPTEMBER', 'IDCS_CALENDAR_OCTOBER', 'IDCS_CALENDAR_NOVEMBER', 'IDCS_CALENDAR_DECEMBER', 'IDCS_CALENDAR_SUNDAY', 'IDCS_CALENDAR_MONDAY', 'IDCS_CALENDAR_TUESDAY', 'IDCS_CALENDAR_WEDNESDAY', 'IDCS_CALENDAR_THURSDAY', 'IDCS_CALENDAR_FRIDAY', 'IDCS_CALENDAR_SATURDAY', 'IDCS_DISK_FULL', 'IDCS_OSC', 'IDCS_AVD', 'IDCS_TRIPWIRE', 'IDCS_PERIMETER', 'IDCS_USER_ERROR_GET_CONFIG_INFO_FAIL'];
  var items = new Array();
  $.each(langKeys, function (i, elem) {
    items[i] = elem;
  });
  try {
    $.ajax({
      type: 'POST',
      async: false,
      url: '/service/Common/getLangContent',
      data: {
        langType: LangCtrl.getLang(),
        items: items
      },
      success: function success(resultObj) {
        var resultDoc = XMLStr2XMLDoc(resultObj.resultXml);
        if ($('response>status', resultDoc).text() == 'success') {
          result += '<setLang>';
          OCXLang = '';
          $('response>content>langItems>item', resultDoc).each(function (i, elem) {
            // if($.inArray($(elem).attr('id'), langKeys) != -1){ // NVM-1920  web发给OCX的翻译，套用getLangContent返回的全部
            // result += "<item id=\"" + $(elem).attr("id") + "\">" + $(elem).text() + "</item>"
            OCXLang += '<item id="' + $(elem).attr('id') + '">' + $(elem).text() + '</item>';
            // }
          });
          result += '</setLang>';
        }
      }
    });
  } catch (ex) {}
  if (notifyFunName) {
    result += '<NotifyFunName>' + notifyFunName + '</NotifyFunName>';
  }
  result += '<systemType>NVMS-9000</systemType>';
  result += '<screenNum>' + (screenNum || 1) + '</screenNum>';
  result += '<uiName>UI1-A</uiName>';
  result += '</cmd>';
  return result;
}

// 加载Windows平台的插件
export function LoadWinPlugin($content, objectId, mimeTypeString, newPluginVer, classid, downLoadUrl) {
  return new Promise(function (resolve, reject) {
    var ocx = null;
    var browserInfo = detectBrowserInfo();
    var browserType = browserInfo.type;
    var browserVersion = browserInfo.majorVersion;
    if (browserType === 'ie') {
      // IE
      var needUpate = true;
      ocx = window.document.createElement('object');
      ocx.classid = 'CLSID:' + classid;
      ocx.id = objectId;
      ocx.width = '100%';
      ocx.height = '100%';
      setTimeout(function () {
        if ('QueryInfo' in ocx) {
          var sendXML = OCX_XML_GetOcxVersion();
          var returnXML = ocx.QueryInfo(sendXML, sendXML.length);
          var $xmlDoc = $("response[type='GetOcxVersion']", $(XMLStr2XMLDoc(returnXML)));
          if ($xmlDoc.length > 0) {
            var intCurVer = $xmlDoc.text();
            if (compareOcxVersion(intCurVer, newPluginVer) >= 0) {
              needUpate = false;
            }
          }
        }
        if (needUpate) {
          setTimeout(function () {
            if ($('.pluginNotic', $content).length === 0) {
              $content.html(getPluginNotice(downLoadUrl));
              $('.pluginNotic', $content).css('padding-top', ($content.height() - $('.pluginNotic', $content).height()) / 2 + 'px');
            }
          }, 500);
          resolve();
        } else {
          $content.append(ocx);
        }
        resolve(ocx);
      }, 500);
    } else {
      // 非IE
      // window.open("chrome://flags/#enable-npapi")
      if (browserType === 'chrome' && browserVersion > 44) {
        $content.html('<div class="pluginNotic" style="font-size: 20px; color: #D90000;">%1</div>'.formatForLang(LangCtrl._L_('请使用ie浏览器预览视频')));
        $('.pluginNotic', $content).css('padding-top', ($content.height() - $('.pluginNotic', $content).height()) / 2 + 'px');
        return;
      } else if (browserType === 'firefox' && browserVersion > 51) {
        $content.html('<div class="pluginNotic" style="font-size: 20px; color: #D90000;">%1</div>'.formatForLang(LangCtrl._L_('IDCS_FIREFOX_VERSION_WARNING')));
        $('.pluginNotic', $content).css('padding-top', ($content.height() - $('.pluginNotic', $content).height()) / 2 + 'px');
        return;
      } else if (browserType === 'opera' && browserVersion > 36) {
        $content.html('<div class="pluginNotic" style="font-size: 20px; color: #D90000;">%1</div>'.formatForLang(LangCtrl._L_('IDCS_OPERA_VERSION_WARNING')));
        $('.pluginNotic', $content).css('padding-top', ($content.height() - $('.pluginNotic', $content).height()) / 2 + 'px');
        return;
      } else if (browserType !== 'chrome' && browserType !== 'firefox' && browserType !== 'opera') {
        $content.html('<div class="pluginNotic" style="font-size: 20px; color: #D90000;">%1</div>'.formatForLang(LangCtrl._L_('IDCS_OTHER_VERSION_WARNING')));
        $('.pluginNotic', $content).css('padding-top', ($content.height() - $('.pluginNotic', $content).height()) / 2 + 'px');
        return;
      }
      var needUpate = true;
      var mimetype = navigator.mimeTypes[mimeTypeString];
      if (mimetype) {
        if (browserType === 'firefox') {
          var contentZIndex = $content.css('z-index');
          if (!contentZIndex || contentZIndex === 'auto' || contentZIndex * 1 < 1) {
            $content.css('z-index', 1);
          }
        }
        $content.html("<object id='" + objectId + "' type='" + mimeTypeString + "' style='width: 100%;height: 100%;'></object>");
        ocx = document.getElementById(objectId);
        var intCurVer = ocx.version; // 找到mimeType类型但没取到版本号，说明已安装但被浏览器拦截
        if (!intCurVer || intCurVer && compareOcxVersion(intCurVer, newPluginVer) >= 0) {
          needUpate = false;
        }
      } else {
        if (browserType === 'chrome') {
          if (browserVersion <= 44) {
            $content.html(getChromeNPAPIDisableNotice(downLoadUrl));
            $('.npapiNotice', $content).css({
              'padding-top': ($content.height() - $('.npapiNotice', $content).height()) / 2 + 'px'
            });
            return;
          }
        }
      }
      if (needUpate) {
        if ($('.pluginNotic', $content).length === 0) {
          $content.html(getPluginNotice(downLoadUrl));
          $('.pluginNotic', $content).css('padding-top', ($content.height() - $('.pluginNotic').height()) / 2 + 'px');
        }
        return;
      }
      resolve(ocx);
    }
  });
}

// 加载MAC平台的插件
function LoadMacPlugin($content, objectId, mimeTypeString, newPluginVer, downLoadUrl) {
  var ocx = null;
  var browserType = detectBrowser();
  if (browserType === 'safari') {
    // safari
    var needUpate = true;
    $content.html("<embed id='" + objectId + "' style='width: 0;height: 100%;' type='" + mimeTypeString + "'></embed>");
    ocx = document.getElementById(objectId);
    if ('QueryInfo' in ocx) {
      var sendXML = OCX_XML_GetOcxVersion();
      var returnXML = ocx.QueryInfo(sendXML, sendXML.length);
      var $xmlDoc = $("response[type='GetOcxVersion']", $(XMLStr2XMLDoc(returnXML)));
      if ($xmlDoc.length > 0) {
        var intCurVer = $xmlDoc.text();
        if (intCurVer && compareOcxVersion(intCurVer, newPluginVer) >= 0) {
          needUpate = false;
          $(ocx).width('100%');
        }
      }
    }
    if (needUpate) {
      if ($('.pluginNotic', $content).length === 0) {
        $(ocx).hide();
        $content.append($(getSafariPluginNotice(downLoadUrl)));
        $('.pluginNotic', $content).css('padding-top', ($content.height() - $('.pluginNotic').height()) / 2 + 'px');
      }
      return;
    }
  } else {
    alert("The plugin don't support current browser!");
  }
  return ocx;
}

// 获取“查询OCX版本号”的XML命令字符串
function OCX_XML_GetOcxVersion() {
  var result = OCX_XML_Header + '<request type="GetOcxVersion"/>';
  return result;
}
function compareOcxVersion(ver1, ver2) {
  var var1Arr = ver1.split(',');
  var var2Arr = ver2.split(',');
  for (var i = 0; i < var1Arr.length; i++) {
    if (var1Arr[i] * 1 > var2Arr[i] * 1) {
      return 1;
    } else if (var1Arr[i] * 1 === var2Arr[i] * 1) {
      continue;
    } else {
      return -1;
    }
  }
  return 0;
}
function getPluginNotice(downLoadUrl) {
  return '<div class="pluginNotic">%1</div>'.formatForLang(LangCtrl._L_('IDCS_NO_PLUGIN_FOR_WINDOWS').formatForLang(downLoadUrl));
}
function getChromeNPAPIDisableNotice(downLoadUrl) {
  return '<div class="npapiNotice">%1</div>'.formatForLang(LangCtrl._L_('IDCS_NPAPI_NOT_SUPPORT').formatForLang(downLoadUrl));
}
function getSafariPluginNotice(downLoadUrl) {
  return '<div class="pluginNotic">%1</div>'.formatForLang(LangCtrl._L_('IDCS_NO_PLUGIN_FOR_MAC').formatForLang(downLoadUrl));
}
window.LiveNotify2Js = function (strXMLFormat, lStrLen) {
  store.commit('twVideo/twbBack', strXMLFormat);
};
window.RecNotify2Js = function (strXMLFormat, lStrLen) {
  store.commit('twRec/twbBack', strXMLFormat);
};
window.TimeSliderNotify2Js = function (strXMLFormat, lStrLen) {
  store.commit('twRec/timeTwbBack', strXMLFormat);
};

// 获取“设置登录信息”的XML命令字符串
export function OCX_XML_SetLoginInfo(username, pwd, ip, port, id, nonce) {
  var usr = XOREncrypt(username, nonce);
  var ppwd = XOREncrypt(SparkMD5.hash(pwd), nonce);
  var result = OCX_XML_Header + '<cmd type="SetLoginInfo">';
  result += '<username>' + usr + '</username>';
  result += '<password>' + ppwd + '</password>';
  result += '<ip>' + ip + '</ip>';
  result += '<port>' + port + '</port>';
  result += '<id>' + id + '</id>';
  result += '<nonce>' + nonce + '</nonce>';
  result += '</cmd>';
  return result;
}

// 获取“设置当前选中通道ID”的XML命令字符串
export function OCX_XML_SetViewChannelID(chlId, chlName) {
  var result = OCX_XML_Header + '<cmd type="SetViewChannelId">';
  result += '<item id="' + chlId + '">' + chlName + '</item>';
  result += '</cmd>';
  return result;
}

// 退出OCX
export function OCX_XML_Leave() {
  return OCX_XML_Header + '<cmd type="Leave"/>';
}

// 全屏
export function OCX_XML_FullScreen() {
  var result = OCX_XML_Header + '<cmd type="FullScreen">';
  result += '</cmd>';
  return result;
}

// 设置录像位置
export function OCX_XML_SetRecLocation(location) {
  var result = OCX_XML_Header + '<cmd type="SetRecLocation">';
  result += location;
  result += '</cmd>';
  return result;
}

// 获取“设置分割屏”的XML命令字符串
export function OCX_XML_SetScreenMode(screenNum, layoutType) {
  var result = OCX_XML_Header + "<cmd type=\"SetScreenMode\" layoutType='" + (layoutType || 1) + "'>";
  result += screenNum;
  result += '</cmd>';
  return result;
}

// 设置OCX属性
export function OCX_XML_SetProperty(properties) {
  var result = OCX_XML_Header + '<cmd type="SetProperty">';
  for (var key in properties) {
    result += '<' + key + '>' + properties[key] + '</' + key + '>';
  }
  result += '</cmd>';
  return result;
}

// 设置录像播放模式--同步/非同步
export function OCX_XML_SetRecPlayMode(mode) {
  var result = OCX_XML_Header + '<cmd type="SetRecPlayMode">';
  result += mode;
  result += '</cmd>';
  return result;
}

// 查询回放录像 cmdType: /*RecPlay/RecSearch/RecSearchNotBindWin*/
export function OCX_XML_SearchRec(cmdType, startTime, endTime, winIndexList, chlIdList, chlNameList, eventList) {
  var result = OCX_XML_Header + '<cmd type="' + cmdType + '">';
  if (startTime) {
    result += '  <startTime>' + startTime + '</startTime>';
  }
  if (endTime) {
    result += '  <endTime>' + endTime + '</endTime>';
  }
  result += '  <chl>';
  for (var i in chlIdList) {
    result += '	<item id="' + chlIdList[i] + '"' + (winIndexList ? ' winIndex="' + winIndexList[i] + '"' : '') + '>' + chlNameList[i] + '</item>';
  }
  result += '  </chl>';
  result += '  <recType>';
  for (var y in eventList) {
    result += '	<item>' + eventList[y] + '</item>';
  }
  result += '  </recType>';
  result += '</cmd>';
  return result;
}

// 设置播放状态
export function OCX_XML_SetPlayStatus(status, winInfo) {
  var result = OCX_XML_Header + '<cmd type="RecPlayStatus">';
  if (winInfo !== null && winInfo !== undefined) {
    result += '<winInfo>' + winInfo + '</winInfo>';
  }
  result += '<status>' + status + '</status>';
  result += '</cmd>';
  return result;
}

// 前进/后退N秒
export function OCX_XML_Skip(time) {
  var result = OCX_XML_Header + '<cmd type="Skip">';
  result += time;
  result += '</cmd>';
  return result;
}